module.exports = __webpack_public_path__ + "img/avatar.20b35932.png";